import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ContactForm.css';
import supabase from '../lib/supabaseClient';

const ContactForm = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (!supabase) {
        throw new Error('Supabase client not initialized');
      }

      const payload = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        phone: formData.phone.trim() || null,
        subject: formData.subject.trim(),
        message: formData.message.trim()
      };

      const { error: insertError } = await supabase
        .from('contact_messages')
        .insert([payload]);

      if (insertError) throw insertError;

      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });

      setTimeout(() => setSubmitted(false), 3000);
    } catch (err) {
      setError(err.message || 'Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact-form section-padding" id="contact">
      <div className="container">
        <div className="contact-grid">
          <div className="contact-image fade-up stagger-1">
            <img 
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=500&h=600&fit=crop" 
              alt="Contact Us"
            />
          </div>

          <div className="contact-content fade-up stagger-2">
            <h2>{t('contact_form_title')}</h2>

            {submitted && (
              <div className="success-message">
                <p>{t('contact_form_success_message')}</p>
              </div>
            )}
            {error && (
              <div className="error-message" style={{ marginTop: '10px' }}>
                <p>{error}</p>
              </div>
            )}

            <form onSubmit={handleSubmit} className="form">
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder={t('contact_form_name_placeholder')}
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder={t('contact_form_email_placeholder')}
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder={t('contact_form_phone_placeholder')}
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="subject"
                  placeholder={t('contact_form_subject_placeholder')}
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  placeholder={t('contact_form_message_placeholder')}
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? t('contact_form_sending_button') : t('contact_form_send_button')}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
